exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message{width:fit-content;border-radius:3px;border-style:dashed;border-width:1px;box-shadow:0 2px 4px rgba(0,0,0,.04);display:flex;font-family:Avenir,Lato,sans-serif;font-size:.9rem;font-weight:500;font-style:italic;justify-content:space-between;margin:1rem 0 1rem auto;padding:.75rem}.message .text{flex:1}.message .close{background-image:url(" + require("../assets/close.svg") + ");background-position:95%;background-repeat:no-repeat;background-size:22px;cursor:pointer;width:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-748eacde!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Message.vue
// module id = 942
// module chunks = 0